import EmptyState from "@/components/EmptyState";
import usePageTitle from "@/hooks/usePageTitle";
import CommissionTabLayout from "../_CommissionTabLayout";
import { useRequireCommissionPlatform } from "../useCommissionPlatformGate";

export default function CommissionReleasePage() {
  usePageTitle("/billing/finance/commission/release", "Release");
  useRequireCommissionPlatform();

  return (
    <CommissionTabLayout>
      <EmptyState title="Coming soon" caption="Release workflows are not available yet." iconName="send" />
    </CommissionTabLayout>
  );
}
